import { Link } from 'react-router-dom';
import Nav from '../../../shared/components/Nav';
import { MENU_CUSTOMER_SERVICE_CENTER } from '../../../shared/constants/app';
import { useEffect, useState } from 'react';
import { updateMenuVisibility } from '../../../utils';
import { getPAGAA000 } from '../../../services/Api';

const PAHAC010 = () => {
    const [customerServiceMenu, setCustomerServiceMenu] = useState([]);

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedCustomerServiceMenu = updateMenuVisibility(data, MENU_CUSTOMER_SERVICE_CENTER);
                setCustomerServiceMenu(updatedCustomerServiceMenu);
            })
            .catch((error) => console.log(error));
    }, []);

    return (
        <div id="content">
            <Nav menu={customerServiceMenu} />
            <div id="user-guide">
                <div className="container">
                    {/* Start title */}
                    {/* <Nav menu={MENU_CUSTOMER_SERVICE_CENTER} /> */}
                    <div className="titleText">이용안내</div>
                    {/* End title */}
                    {/* Start user-guide-content */}
                    <div className="user-guide-content">
                        <div className="user-guide-content-child-2">
                            <div className="content-title">
                                <div className="outer-circle" />
                                <div className="text-content-title">개인회원</div>
                            </div>
                            <div className="text-content-title-child">
                                구직을 원하시는 회원님을 위해 다음과 같은 서비스가 준비되어 있습니다.
                            </div>
                            <div className="vertical-line" />
                            <div className="content-child">
                                <div className="item-content">
                                    <div className="title-content-child">이력서 등록 방법</div>
                                    <ul className="item-text-arrow">
                                        <div className="line-item line-1">
                                            <div className="item">
                                                <li className="item-arrow">‘개인회원’으로 가입</li>
                                            </div>
                                            <div className="item">
                                                <li className="item-arrow">‘개인회원’으로 로그인</li>
                                            </div>
                                            <div className="item">
                                                <li className="item-arrow">
                                                    ‘마이 페이지 &gt; 이력서 등록’
                                                    <br />
                                                    메뉴 클릭
                                                </li>
                                            </div>
                                            <div className="item">
                                                <li className="item-arrow">상세내용 입력</li>
                                            </div>
                                            <div className="item">
                                                <li className="item-arrow">‘등록하기’ 버튼 클릭</li>
                                            </div>
                                            <div className="item">
                                                <li className="item-arrow">인재정보 등록완료</li>
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                                {/* Start company Introduction */}
                                <div id="company-introduction">
                                    <div className="row">
                                        <div className="col">
                                            <ul className="join-membership">
                                                <li>
                                                    <div className="icon icon-people" />
                                                </li>
                                                <li className="title">회원가입</li>
                                                <li className="content">
                                                    대한민국 치과계 No.1
                                                    <br />
                                                    구인구직 사이트
                                                    <br />
                                                    덴탈잡에서 무료로
                                                    <br />
                                                    가입하세요.
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col">
                                            <ul className="join-membership">
                                                <li>
                                                    <div className="icon icon-file" />
                                                </li>
                                                <li className="title">이력서 등록</li>
                                                <li className="content">
                                                    이력서를 등록하시고
                                                    <br />
                                                    덴탈잡의 인재로
                                                    <br />
                                                    거듭나세요.
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col">
                                            <ul className="join-membership">
                                                <li>
                                                    <div className="icon icon-up" />
                                                </li>
                                                <li className="title">이력서 JUMP UP</li>
                                                <li className="content">
                                                    회원님의 이력서를 Jump up
                                                    <br />
                                                    하시면 목록 맨 앞으로
                                                    <br />
                                                    이동합니다.
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col">
                                            <ul className="join-membership">
                                                <li>
                                                    <div className="icon icon-computer" />
                                                </li>
                                                <li className="title">온라인 입사지원</li>
                                                <li className="content">
                                                    덴탈잡에서 작성한
                                                    <br />
                                                    이력서로 바로
                                                    <br />
                                                    입사지원이 가능합니다.
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col">
                                            <ul className="join-membership">
                                                <li>
                                                    <div className="icon icon-find-people" />
                                                </li>
                                                <li className="title">채용정보 검색</li>
                                                <li className="content">
                                                    나에게 맞는
                                                    <br />
                                                    채용정보를 검색할 수
                                                    <br />
                                                    있습니다.
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col">
                                            <ul className="join-membership">
                                                <li>
                                                    <div className="icon icon-star-blue" />
                                                </li>
                                                <li className="title">관심 채용정보 보관</li>
                                                <li className="content">
                                                    관심있게 보고 있는
                                                    <br />
                                                    치과의 채용정보를 My초이스에
                                                    <br />
                                                    저장할 수 있습니다.
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                {/* End company Introduction */}
                            </div>
                        </div>
                    </div>

                    <div className="user-guide-content">
                        <div className="user-guide-content-child-1">
                            <div className="content-title">
                                <div className="outer-circle green" />
                                <div className="text-content-title">치과회원</div>
                            </div>
                            <div className="text-content-title-child">
                                구인을 원하시는 회원님을 위해 다음과 같은 서비스가 준비되어 있습니다.
                            </div>
                            <div className="vertical-line" />
                            <div className="content-child">
                                <div className="item-content">
                                    <div className="title-content-child">채용정보 등록 방법</div>
                                    <ul className="item-text-arrow">
                                        <div className="line-item line-2">
                                            <div className="item">
                                                <li className="item-arrow">‘치과회원’으로 가입</li>
                                            </div>
                                            <div className="item">
                                                <li className="item-arrow">‘치과회원’으로 로그인</li>
                                            </div>
                                            <div className="item">
                                                <li className="item-arrow">
                                                    ‘마이 페이지 &gt; 채용정보 등록’
                                                    <br />
                                                    메뉴 클릭
                                                </li>
                                            </div>
                                            <div className="item">
                                                <li className="item-arrow">채용내역 입력</li>
                                            </div>
                                            <div className="item">
                                                <li className="item-arrow">
                                                    상품선택
                                                    <br />
                                                    (채용정보, 배너 등)
                                                </li>
                                            </div>
                                            <div className="item">
                                                <li className="item-arrow">
                                                    결제방법 선택
                                                    <br />
                                                    (카드결제 및 입금)
                                                </li>
                                            </div>
                                            <div className="item">
                                                <li className="item-arrow">덴탈잡 승인</li>
                                            </div>
                                            <div className="item">
                                                <li className="item-arrow">채용정보 등록완료</li>
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                                {/* Start group-recommend */}
                                <div id="group-recommend">
                                    <Link className="btn-recommend-use" to="/pahab010">
                                        <div className="text-rcm-use">채용광고 상품안내</div>
                                        <div className="icon-right" />
                                    </Link>
                                    <div className="title-item">
                                        배너 및 강조 상품 등 덴탈잡의 다양한 상품으로 회원님의 채용정보를 눈에 띄게
                                        해보세요!
                                    </div>
                                </div>
                                {/* End group-recommend */}
                                {/* Start company Introduction */}
                                <div id="company-introduction">
                                    <div className="row">
                                        <div className="col">
                                            <ul className="join-membership">
                                                <li>
                                                    <div className="icon icon-people" />
                                                </li>
                                                <li className="title">회원가입</li>
                                                <li className="content">
                                                    대한민국 치과계 No.1
                                                    <br />
                                                    구인구직 사이트
                                                    <br />
                                                    덴탈잡에서 무료로
                                                    <br />
                                                    가입하세요.
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col">
                                            <ul className="join-membership">
                                                <li>
                                                    <div className="icon icon-mouse" />
                                                </li>
                                                <li className="title">채용정보 등록</li>
                                                <li className="content">
                                                    세부 사항을
                                                    <br />
                                                    꼼꼼히 입력하여
                                                    <br />
                                                    채용광고를 등록하세요.
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col">
                                            <ul className="join-membership">
                                                <li>
                                                    <div className="icon icon-up" />
                                                </li>
                                                <li className="title">채용정보 JUMP UP</li>
                                                <li className="content">
                                                    회원님의 채용정보를
                                                    <br />
                                                    Jump up 하시면
                                                    <br />
                                                    목록 맨 앞으로 이동합니다.
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col">
                                            <ul className="join-membership">
                                                <li>
                                                    <div className="icon icon-image" />
                                                </li>
                                                <li className="title">포토채용 등록</li>
                                                <li className="content">
                                                    치과 사진과 함께
                                                    <br />
                                                    우리 치과를 자랑해 주시면
                                                    <br />
                                                    구인이 더욱 쉬워집니다.
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col">
                                            <ul className="join-membership">
                                                <li>
                                                    <div className="icon icon-very-people" />
                                                </li>
                                                <li className="title">인재정보 열람</li>
                                                <li className="content">
                                                    우리 치과에 맞는
                                                    <br />
                                                    인재정보를 검색하고
                                                    <br />
                                                    직접 연락하실 수 있습니다.
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col">
                                            <ul className="join-membership">
                                                <li>
                                                    <div className="icon icon-referral-card" />
                                                </li>
                                                <li className="title">덴탈잡 지원자 관리</li>
                                                <li className="content">
                                                    덴탈잡에서 온라인으로
                                                    <br />
                                                    입사지원한 인재 내역을
                                                    <br />
                                                    간편하게 확인할 수 있습니다.
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                {/* End company Introduction */}
                            </div>
                        </div>
                    </div>

                    {/* Start bottom-note */}
                    <div className="bottom-note">
                        <div className="img-text-bottom" />
                        <div className="title-bottom-note">믿음이 있어 아름다운 채용/취업 문화</div>
                        <div className="content-bottom-note">
                            <p>면접 결과에 관계없이 지원자와의 소중한 인연에 감사할 줄 압니다.</p>
                            <p>약속된 면접에 참석할 수 없을때는 사전에 미리 연락하는 것이 기본 매너입니다.</p>
                            <p>아름다운 인연을 만들고 에티켓을 지킬줄 아는 우리는 덴탈잡 회원입니다.</p>
                        </div>
                    </div>
                    {/* End bottom-note */}
                </div>
            </div>
        </div>
    );
};

export default PAHAC010;
